var map = {
	"./add-zastave.webp": 5756,
	"./zastave (1).webp": 8722,
	"./zastave (2).webp": 4011,
	"./zastave (3).webp": 4057,
	"./zastave (4).webp": 2949,
	"./zastave (5).webp": 7168,
	"./zastave (6).webp": 7618,
	"./zastave (7).webp": 6742,
	"./zastave (8).webp": 3365,
	"./zastave (9).webp": 486,
	"./zastave-add.webp": 9215,
	"./zastavecover.webp": 1772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;